import type { Messages } from "./en";

export const ja: Messages = {
  "nav.home": "LEARNABLE ホーム",
  "nav.main": "メイン",
  "nav.courses": "コース",
  "nav.review": "復習",
  "nav.progress": "進捗",
  "nav.guide": "ガイド",
  "nav.marketplace": "マーケット",
  "nav.streak": "連続学習日数：{n}",
  "nav.xp": "合計経験値：{n} XP",

  "account.menu": "アカウント",
  "account.settings": "設定",
  "account.guide": "LEARNABLE の使い方",
  "account.signOut": "ログアウト",

  "common.save": "保存",
  "common.saved": "保存しました。",
  "common.saving": "保存中…",
  "common.cancel": "キャンセル",
  "common.close": "閉じる",
  "common.pleaseWait": "お待ちください…",

  "signin.title": "LEARNABLE にログイン",
  "signin.registerTitle": "アカウントを作成",
  "signin.email": "メールアドレス",
  "signin.password": "パスワード",
  "signin.passwordRule": "12 文字以上。",
  "signin.submit": "ログイン",
  "signin.register": "アカウントを作成",
  "signin.forgot": "パスワードをお忘れですか？",
  "signin.toRegister": "新しいアカウントを作成",
  "signin.toSignIn": "すでにアカウントをお持ちの方",
  "signin.language": "言語",

  "password.current": "現在のパスワード",
  "password.new": "新しいパスワード（12 文字以上）",
  "password.change": "パスワードを変更",
  "password.changed": "パスワードを変更しました。ほかの端末はログアウトされました。",

  "settings.title": "設定",
  "settings.intro": "プロフィールと各種設定です。アカウントに保存され、すべての端末に反映されます。",
  "settings.profile": "プロフィール",
  "settings.displayName": "表示名",
  "signin.emailOrUsername": "メールまたはユーザー名",
  "signin.username": "ユーザー名(任意)",
  "signin.usernameHint": "3〜30文字の英数字、ピリオド、アンダースコア、ハイフン。メールの代わりにこれでサインインできます。",
  "settings.username": "ユーザー名",
  "settings.usernameHint": "任意。メールの代わりにこの名前でサインインできます。他の人には表示されません。空にすると削除されます。",
  "settings.displayNameHint": "メールアドレスの代わりに表示されます。空欄にするとメールアドレスを使います。",
  "settings.email": "メールアドレス",
  "settings.emailHint": "ログインに使うアドレスです。",
  "settings.language": "言語",
  "settings.languageHint": "メニューとページの言語です。コースの教材と AI のフィードバックは、コース自体の言語のままです。",
  "settings.translationNote": "翻訳作業中です。一部の画面はまだ英語で表示されます。",
  "settings.study": "学習",
  "settings.timezone": "タイムゾーン",
  "settings.timezoneHint": "学習日、連続学習日数、1 日の目標はこのタイムゾーンに従います。",
  "settings.dailyGoal": "1 日の目標",
  "settings.dailyGoalHint": "1 日に答える問題数。",
  "settings.security": "セキュリティ",
  "settings.signOutHint": "ログアウトすると、このブラウザからアカウントのデータが削除されます。",

  "guide.title": "LEARNABLE の使い方",
  "guide.intro": "LEARNABLE は、あなた自身の学習教材を問題に変え、解答をチェックし、忘れる直前に次の復習を予定します。",
  "guide.contents": "目次",
  "guide.structure.title": "1. コースの構成",
  "guide.structure.body": "コースは章に分かれ、章はトピックに、トピックはコンセプトに分かれます。各コンセプトには学習項目があります。覚えるべき内容で、それぞれ 1 つ以上の問題で出題されます。",
  "guide.material.title": "2. 教材を追加する",
  "guide.material.body": "コースを開き、PDF、Word、PowerPoint、テキスト、Markdown のファイルをアップロードするか、テキストを貼り付けます。問題と答えがすでにある場合は、\"Question:\" と \"Answer:\"（または \"Domanda:\" と \"Risposta:\"）で始まる行でアップロードしてください。それぞれが AI を使わずにコンセプトになります。",
  "guide.curriculum.title": "3. カリキュラムを作る",
  "guide.curriculum.body": "教材から章、トピック、コンセプトを提案するよう AI に依頼します。提案を確認し、名前の変更、移動、削除を自由に行ってから承認します。承認するまで何も変わりません。",
  "guide.study.title": "4. コンセプトを学習する",
  "guide.study.body": "概念を開いて「有効化」を押すと、資料から学習項目が作られます。読んだら「この概念を学習した」を押してください。各問題は三回うまく答えられるまで(連続でなくてかまいません)出題され、回答のたびにフィードバックがあります。",
  "guide.answer.title": "5. 解答してフィードバックを受ける",
  "guide.answer.body": "自分の言葉で答えを書くか、\"声で答える\" を押して音声で入力します。ヒントも使えますが、XP が半分になります。AI は言葉そのものではなく意味を判断し、4 つのスコアと、正しかった点・足りない点・誤りの一覧を表示します。模範解答とその出典はいつでもワンクリックで見られます。",
  "guide.disagree.title": "6. 評価に納得できないとき",
  "guide.disagree.body": "\"Disagree with the grade?\" を押します。理由を説明して AI にもう一度評価してもらう（両方の結果が表示されます）か、自分で評価することができます。自分の評価が常に優先されます。",
  "guide.review.title": "7. タイミングよく復習する",
  "guide.review.body": "解答するたびに、その問題が復習の予定に組み込まれます。よく覚えているほど、次に出題されるまでの間隔が長くなります。復習ページとダッシュボードに、期限の来た問題とおおよその所要時間が表示されます。",
  "guide.progress.title": "8. 進捗を確認する",
  "guide.progress.body": "連続学習日数は学習した日を数え、XP は正解に与えられ、1 日の目標で学習のペースが決まります。\"間違え続けているところ\" には最近の解答で見つかった誤りがまとめられ、練習ボタンもあります。",
  "guide.organise.title": "9. 整理する",
  "guide.organise.body": "\"問題を管理\" では、個々の問題や、章・トピック・コンセプトをまとめて選択し、削除、一時停止、再開、移動ができます。問題の編集や、⠿ をドラッグしての並べ替えもできます。長いセクションはタイトル横の矢印で折りたためます。",
  "guide.marketplace.title": "10. コースを共有・入手する",
  "guide.marketplace.body": "マーケットでは、他のユーザーが作ったコースをカテゴリー、レベル、言語、規模で探せます。追加する前にコースのページを確認できます：内容、対象者、学べること、章、問題数。\"マイコースに追加\" を押すとダッシュボードに追加されます。問題は作成者が更新し、あなたは編集できませんが、学習はあなた自身のものです（計画、回答、XP、各問題に付ける優先度）。作成者の資料はダウンロードできません。自分のコースを共有するには、コースを開いて \"マーケットページ\" を書き、下書きとして保存してから公開します。",
  "guide.glossary.title": "アプリで使う用語",
  "guide.term.concept": "コンセプト",
  "guide.term.concept.def": "コースの 1 つの考え方。定義や規則など。",
  "guide.term.item": "学習項目",
  "guide.term.item.def": "コンセプトの中の覚えるべき 1 つの内容。問題と期待される答えがあります。",
  "guide.term.active": "Active（有効）",
  "guide.term.active.def": "そのコンセプトは学習と復習の対象になります。一時停止中や未学習のものは対象外です。",
  "guide.term.grades": "もう一度 · 難しい · 良い · 簡単",
  "guide.term.grades.def": "もう一度・難しい・良い・簡単：答えをどれだけ知っていたか。次に問題が出るタイミングを決めます。",
  "guide.term.mastery": "習熟度",
  "guide.term.mastery.def": "復習の結果から推定した、コンセプトをどれだけ覚えているかの目安です。",
  "guide.term.xp": "XP と連続日数",
  "guide.term.xp.def": "正解でもらえるポイントと、連続して学習した日数です。",
  "guide.privacy.title": "あなたのデータ",
  "guide.privacy.body": "コース、解答、進捗はあなただけが見られます。音声入力はブラウザが文字に変換し、保存されるのは文字だけです。",
  "help.button": "ヘルプ：{topic}",
  "help.more": "詳しく見る",
  "help.nextStep": "今いちばん役に立つこと。期限の来た復習が常に先で、そのあとに新しい内容が続きます。",
  "help.courses": "コースごとに 1 枚のカード。緑のボタンで期限の来た復習、青のボタンで新しい内容に進みます。",
  "help.streak": "1 問以上答えた日が続いている日数です。今日 1 問答えると続きます。",
  "help.xp": "正解でもらえる経験値です。ヒントを使うと半分になります。",
  "help.goal": "1 日に答えたい問題数です。設定で変更できます。",
  "help.planner": "各時点までに期限が来る問題数と、おおよその所要時間です。",
  "help.coursePlanner": "このコースのみ:問題がいつ復習期限になるか、おおよその所要時間。新しい教材は問題ごとに最低三回の良い回答が必要です。",
  "help.activity": "1 日 1 マス。色が濃いほどたくさん答えています。",
  "help.concept": "コンセプトはコースの 1 つの考え方です。学習を始めて問題を準備し、学習項目を読んでから練習します。",
  "help.consolidate": "下の学習項目を読んだらボタンを押してください。各問題は三回うまく答えられるまで出題され、しっかり定着します。",
  "help.study": "自分の言葉で書くか、音声で答えてください。AI は言葉ではなく意味を判断し、正しい点と足りない点を示します。",
  "help.questions": "個々の問題や、章・トピック・コンセプト全体にチェックを入れ、削除・一時停止・移動ができます。⠿ をドラッグして並べ替えます。",
  "help.marketplace": "他のユーザーが作ったコースです。開くと内容と問題数がわかります。追加すると自分の計画で学習できます。作成者が更新を続けます。",
  "help.weakSpots": "最近の解答で見つかった誤りをコンセプトごとにまとめています。一覧から消えるまで練習しましょう。",
  "help.material": "PDF、Word、PowerPoint、テキストのファイルをアップロードするか、テキストを貼り付けます。LEARNABLE がそこからコースと問題を作ります。",
  "start.title": "LEARNABLE の使い方",
  "start.intro": "4 つのステップ。どれかを開くとガイドで確認できます。",
  "start.hide": "わかりました。非表示にする",
  "start.reopen": "LEARNABLE の使い方を表示",
  "start.material.title": "教材を追加",
  "start.material.body": "コースを作り、ノート、スライド、本をアップロードするか、テキストを貼り付けます。",
  "start.plan.title": "計画を承認",
  "start.plan.body": "AI が章とコンセプトを提案します。自由に変更してから承認します。",
  "start.study.title": "学習して解答",
  "start.study.body": "コンセプトを読んでから、その問題に自分の言葉や音声で答えます。",
  "start.review.title": "タイミングよく復習",
  "start.review.body": "忘れる直前に問題が戻ってきます。緑のボタンに従ってください。",
  "nav.community": "コミュニティ",
  "community.title": "コミュニティ",
  "community.intro": "誰が一番経験値を稼いでいるかを見て、他の学習者をフォローして応援しましょう。",
  "community.tab.leaderboard": "ランキング",
  "community.tab.friends": "友達",
  "community.period": "期間",
  "community.scope": "対象",
  "community.period.day": "今日",
  "community.period.week": "今週",
  "community.period.month": "今月",
  "community.period.all": "全期間",
  "community.scope.everyone": "全員",
  "community.scope.friends": "友達",
  "community.leader": "トップ",
  "community.xp": "{n} XP",
  "community.you": "あなた",
  "community.yourPlace": "あなたの順位",
  "community.empty": "この期間はまだ誰も XP を獲得していません。",
  "community.emptyFriends": "他の学習者をフォローすると、ここで比較できます。",
  "community.windowNote": "日付は UTC 基準で、週は月曜日に始まります。コミュニティに参加した人だけが表示されます。",
  "community.joinTitle": "コミュニティに参加",
  "community.joinText": "まだランキングに載っていません。コミュニティでの公開をオンにすると、ランキングに表示され、他の人に見つけてもらえ、フォローされます。他の人に見えるのは表示名と XP だけで、メールアドレスは見えません。",
  "community.joinButton": "コミュニティに表示する",
  "community.needName": "先に設定で表示名を決めてください。",
  "community.follow": "フォロー",
  "community.following": "フォロー中",
  "community.friend": "友達",
  "community.followsYou": "あなたをフォロー中",
  "community.since": "{date} から学習中",
  "community.statXpTotal": "合計 XP",
  "community.statXpWeek": "今週の XP",
  "community.statStreak": "連続日数",
  "community.statFollowers": "フォロワー",
  "community.statFollowing": "フォロー中",
  "community.followingList": "フォローしている人",
  "community.followersList": "あなたのフォロワー",
  "community.searchLabel": "名前で学習者を探す",
  "community.searchPlaceholder": "表示名で検索",
  "community.search": "検索",
  "community.noResults": "見つかりませんでした。コミュニティに参加した人だけが検索できます。",
  "community.noFollowing": "まだ誰もフォローしていません。",
  "community.noFollowers": "まだフォロワーはいません。",
  "community.streakDays": "{n} 日連続",
  "community.xpToday": "今日 {n} XP",
  "community.notFound": "このプロフィールは利用できません。",
  "community.seeLeaderboard": "コミュニティのランキングを見る",
  "course.leaderboardLink": "コースのランキング",
  "course.leaderboardTitle": "コースのランキング",
  "course.leaderboardIntro": "このコースを持つ全員がこのコースで獲得した XP。",
  "course.leaderboardPrivate": "これは非公開のコースなので、ランキングにはあなたしかいません。マーケットのコースは、それを持つ全員と共有されます。",
  "course.leaderboardParticipants": "{n} 人の学習者がこのコースを共有しています。",
  "settings.community": "コミュニティ",
  "settings.communityToggle": "コミュニティに表示する（ランキング、検索、フォロー）",
  "settings.communityHint": "初期状態ではオフです。他の人に見えるのは表示名、XP、連続日数だけで、メールアドレス、コース、回答は見えません。オンにするには表示名が必要です。",
  "study.repeat.badge": "あと少し：もう一度答えましょう",
  "study.repeat.title": "模範解答を確認してから、もう一度答えましょう",
  "study.repeat.body": "回答はほとんどの点で良くできていました。上の模範解答を読み、自分の言葉でもう一度書いてください。うまく言えれば正解として扱われ、スケジュールが進みます。そうでなければレベル0に戻ります。",
  "study.repeat.label": "もう一度あなたの回答",
  "study.repeat.submit": "もう一度答える",
  "study.repeat.selfGrade": "代わりに自分で採点する",
  "study.repeat.evalTitle": "復唱の評価",
  "error.generic": "問題が発生しました。もう一度お試しください。",
  "error.transport": "サーバーに接続できません。接続を確認してもう一度お試しください。",
  "error.session": "セッションの有効期限が切れました。もう一度サインインしてください。",
  "error.validation": "入力された情報の一部が正しくありません。",
  "error.notFound": "この項目はもう存在しません。",
  "error.tooLarge": "このファイルは大きすぎます。",
  "error.unsupported": "このファイル形式には対応していません。PDF、Word、PowerPoint、テキスト、Markdown のファイルを使用してください。",
  "error.aiNotConfigured": "サーバーで AI がまだ設定されていません。",
  "error.aiUnavailable": "AI は一時的に利用できません。しばらくしてからもう一度お試しください。",
  "error.aiInvalid": "AI の応答が使用できませんでした。もう一度お試しください。",
  "error.state": "現在の状態ではその操作はできません。",
  "error.server": "サーバーで問題が発生しました。もう一度お試しください。",
  "error.rateLimited": "試行回数が多すぎます。しばらく待ってからもう一度お試しください。",
  "error.managedCourse": "このコースはマーケットのものです。作成者が更新を続けるため、ここでは内容を変更できません。",
  "studyState.NOT_STUDIED": "未学習",
  "studyState.STUDIED": "学習済み",
  "studyState.ACTIVE": "学習中",
  "studyState.PAUSED": "一時停止中",
  "studyState.COMPLETED": "完了",
  "memoryState.NEW": "新規",
  "memoryState.LEARNING": "学習中",
  "memoryState.REVIEW": "復習中",
  "memoryState.RELEARNING": "再学習中",
  "memoryState.MASTERED": "習得済み",
  "outcome.AGAIN": "もう一度",
  "outcome.HARD": "難しい",
  "outcome.GOOD": "良い",
  "outcome.EASY": "簡単",
  "outcomeHelp.AGAIN": "分からなかった",
  "outcomeHelp.HARD": "分かったが苦労した",
  "outcomeHelp.GOOD": "分かった",
  "outcomeHelp.EASY": "簡単に分かった",
  "classification.CORRECT": "正解",
  "classification.PARTIALLY_CORRECT": "部分的に正解",
  "classification.MISCONCEPTION": "誤解",
  "classification.WRONG": "不正解",
  "classification.UNCERTAIN": "不確か",
  "role.CORE_TRAINABLE": "中核",
  "role.SUPPORTING_TRAINABLE": "補足",
  "role.COMMON_TRAP": "よくある落とし穴",
  "role.INFORMATIONAL": "情報",
  "role.REFERENCE": "参照",
  "role.OPTIONAL_EXTENSION": "任意",
  "priority.1": "必須",
  "priority.2": "重要",
  "priority.3": "追加",
  "label.page": "{n} ページ",
  "label.pages": "{a}–{b} ページ",
  "label.pageShort": "{n}頁",
  "label.pagesShort": "{a}–{b}頁",
  "category.law": "法律",
  "category.economics_business": "経済・ビジネス",
  "category.accounting_finance": "会計・金融",
  "category.medicine_health": "医学・健康",
  "category.sciences": "科学",
  "category.mathematics": "数学",
  "category.engineering": "工学",
  "category.computer_science": "情報科学",
  "category.languages": "語学",
  "category.humanities": "歴史・人文学",
  "category.arts": "芸術・音楽",
  "category.professional_exams": "資格試験",
  "category.other": "その他",
  "level.all": "全レベル",
  "level.beginner": "初級",
  "level.intermediate": "中級",
  "level.advanced": "上級",
  "size.small": "短い（50問未満）",
  "size.medium": "中程度（50〜299問）",
  "size.large": "大規模（300問以上）",
  "sort.popular": "人気順",
  "sort.newest": "新着順",
  "sort.largest": "問題数順",
  "lang.it": "イタリア語",
  "lang.en": "英語",
  "price.free": "無料",
  "common.loading": "読み込み中…",
  "common.tryAgain": "再試行",
  "common.dismiss": "閉じる",
  "common.delete": "削除",
  "common.edit": "編集",
  "common.rename": "名前を変更",
  "common.title": "タイトル",
  "common.description": "説明",
  "common.continue": "続ける",
  "common.search": "検索",
  "common.add": "追加",
  "common.remove": "削除",
  "common.yes": "はい",
  "common.no": "いいえ",
  "common.collapse": "{label} を折りたたむ",
  "common.expand": "{label} を展開",
  "drag.item": "項目",
  "drag.reorder": "{label} を並べ替える",
  "drag.pickedUp": "{label} をつかみました。{total} 件中 {pos} 番目。",
  "drag.over": "{label} は {total} 件中 {pos} 番目になりました。",
  "drag.dropped": "{label} を {total} 件中 {pos} 番目に置きました。",
  "drag.droppedPlain": "{label} を置きました。",
  "drag.cancelled": "{label} の移動をキャンセルしました。",
  "drawing.loadFailed": "図を読み込めませんでした。",
  "course.authorOrder": "このコースの順序は作成者が決めます。",
  "priority.yours": "あなたの優先度",
  "priority.label": "優先度",
  "priority.author": "作成者：{name}",
  "priority.useAuthor": "作成者の設定を使う",
  "editTitle.rename": "{label}の名前を変更",
  "label.course": "コース",
  "label.chapter": "章",
  "label.topic": "トピック",
  "label.concept": "コンセプト",
  "library.heading": "マイコース",
  "library.count.one": "{n} コース",
  "library.count.other": "{n} コース",
  "library.shownOf": "{total} 件中 {shown} 件を表示",
  "library.search": "コースを検索",
  "library.show": "表示",
  "library.sortBy": "並べ替え",
  "library.new": "+ 新しいコース",
  "library.marketplace": "🛒 マーケット",
  "library.empty": "まだコースがありません。コースを作成し、学習資料や自分の問題と答えを追加しましょう。",
  "library.createFirst": "最初のコースを作成",
  "library.noMatch": "この検索や絞り込みに一致するコースはありません。",
  "libStatus.all": "すべてのコース",
  "libStatus.in_progress": "学習中",
  "libStatus.not_started": "未開始",
  "libStatus.due": "復習が必要",
  "libStatus.completed": "新しく学ぶことはありません",
  "libStatus.paused": "一時停止中",
  "libStatus.archived": "アーカイブ済み",
  "libSort.recent_study": "最近学習した順",
  "libSort.recent_created": "最近作成した順",
  "libSort.alphabetical": "五十音順",
  "libSort.most_due": "復習が多い順",
  "card.marketplacePill": "🛒 マーケットより · 作成者 {author}",
  "card.marketplaceHint": "作成者が内容を更新し続けます。学習は自分のものです。",
  "card.continue": "続き",
  "card.next": "次",
  "card.archived": "アーカイブ済み",
  "card.paused": "一時停止中",
  "card.conceptsStudied": "個のコンセプトを学習済み",
  "card.itemsIntroduced": "個の学習項目を導入済み",
  "card.moreFor": "{title} のその他の操作",
  "menu.details": "コースの詳細",
  "menu.material": "学習資料",
  "menu.progress": "進捗",
  "menu.publish": "🛒 マーケットに公開",
  "menu.pause": "一時停止",
  "menu.resume": "再開",
  "menu.archive": "アーカイブ",
  "menu.restore": "元に戻す",
  "menu.delete": "削除…",
  "menu.confirmOwn": "「{title}」を削除しますか？章、問題、資料、あなたの回答は完全に削除されます。すべて残すにはアーカイブを使ってください。",
  "menu.confirmMarketplace": "「{title}」を削除しますか？マーケットから無料でもう一度追加できます。",
  "newCourse.aria": "新しいコース",
  "newCourse.language": "資料の言語",
  "newCourse.create": "コースを作成",
  "learn.resume.label": "練習を再開",
  "learn.resume.hint": "中断したラウンドを続けます",
  "learn.study.label": "次を学ぶ",
  "learn.study.hint": "{title} を学ぶ",
  "learn.study.hintNone": "新しい内容を学ぶ",
  "learn.activate.label": "学習を始める",
  "learn.activate.hint": "{title} の問題を準備して学習を始めます",
  "learn.activate.hintNone": "次のコンセプトの学習を始めます",
  "learn.setup.label": "資料を追加",
  "learn.setup.hint": "学習資料か自分の問題を追加して始めましょう",
  "learn.none.label": "すべて学習済み ✓",
  "learn.none.hint": "このコースのすべてを学習しました",
  "review.none": "✓ 今は復習するものがありません",
  "review.noneTitle": "このコースで今復習が必要なものはありません",
  "review.aria.one": "{n} 件を復習",
  "review.aria.other": "{n} 件を復習",
  "review.button": "復習",
  "course.practiceHard": "難しい問題を練習",
  "course.chapters": "章",
  "course.chaptersEmpty": "章を追加してから、学習資料を加えましょう。",
  "course.chapterMeta": "{total} 個中 {active} 個のコンセプトが学習中 · 習熟度 {mastery}",
  "course.newChapter": "新しい章のタイトル",
  "course.addChapter": "章を追加",
  "course.curriculum": "カリキュラム",
  "course.fallback": "コース",
  "course.allMaterial": "すべての学習資料",
  "course.manageQuestions": "問題を管理",
  "course.weakSpots": "間違え続けているところ",
  "chapter.gone": "この章はもう存在しません。",
  "chapter.topics": "トピック",
  "chapter.starting": "分析を開始しています…",
  "chapter.analyze": "新しい資料を分析",
  "chapter.analyzeHint": "AI がまだ分析していない資料からトピックとコンセプトを提案します。変更の前に提案を確認できます。",
  "chapter.noMaterial": "この章には分析する新しい資料がありません。先に資料をアップロードしてください。",
  "chapter.empty": "まだトピックがありません。下に資料をアップロードして分析しましょう。",
  "chapter.topicMeta": "{total} 個中 {active} 個のコンセプトが学習中",
  "topic.gone": "このトピックはもう存在しません。",
  "topic.concepts": "コンセプト",
  "topic.empty": "このトピックにコンセプトはありません。",
  "topic.needsReview": "出典の確認が必要",
  "topic.conceptMeta": "{state} · 習熟度 {mastery}",
  "unit.item.one": "{n} 件",
  "unit.item.other": "{n} 件",
  "unit.answer.one": "{n} 回答",
  "unit.answer.other": "{n} 回答",
  "consolidate.continue": "定着を続ける",
  "consolidate.unfinished": "{items} のまとまりは未完了です。残り {left}。回答済みの内容は保持されます。",
  "consolidate.resume": "再開",
  "consolidate.doneTitle": "定着済み",
  "consolidate.doneBody": "このコンセプトのすべての項目が定着ラウンドを終えました。期限が来ると復習に戻ってきます。",
  "consolidate.title": "このコンセプトを学びましたか？",
  "consolidate.body": "まず上の学習内容を読んでください。準備ができたら、各問題は {n} 回うまく答えられるまで(連続でなくてかまいません)出題され、回答のたびにフィードバックがあります。",
  "consolidate.batch": "このバッチ：{items} · {answers}",
  "consolidate.more.one": "あと {n} 件は後のバッチを待っています",
  "consolidate.more.other": "あと {n} 件は後のバッチを待っています",
  "consolidate.button": "このコンセプトを学びました",
  "breadcrumb.aria": "パンくずリスト",
  "dash.title": "ダッシュボード",
  "dash.loading": "ダッシュボードを読み込み中…",
  "dash.aside": "あなたの学習",
  "dash.today": "今日",
  "dash.xpTodayPlus": "今日 +{n} XP",
  "dash.goal": "目標 {done}/{target}",
  "dash.tzNote": "学習日（連続日数、目標、今日の XP）は {zone} に従います。この端末は {device} です。",
  "dash.tzUse": "{zone} を使う",
  "next.title": "次のステップ",
  "next.resumeTitle": "定着を続ける · 良い回答 {round}/{total}",
  "next.answersLeft": "残り {n} 回答",
  "next.resume": "再開",
  "next.minutes": "約 {n} 分",
  "next.startReview": "復習を始める",
  "next.learnTitle": "学習を続ける：{concept}",
  "next.nextConcept": "次のコンセプト",
  "next.learn": "学ぶ",
  "next.setupTitle": "{concept} を準備",
  "next.theNextConcept": "次のコンセプト",
  "next.setupDetail": "{course} · 有効化して問題を準備します",
  "next.setup": "準備",
  "next.addMaterialTitle": "{course} に資料を追加",
  "next.yourCourse": "あなたのコース",
  "next.addMaterialDetail": "学習資料や自分の問題と答えをアップロードして、コンセプトを作りましょう。",
  "next.firstCourse": "最初のコースを始めよう",
  "next.firstCourseDetail": "コースを作成し、資料や自分の問題を追加しましょう。",
  "next.caughtUp": "すべて完了しました",
  "next.caughtUpDetail": "期限のものも、待機中の新しい資料もありません。",
  "streak.title": "毎日の連続記録",
  "streak.unit.one": "日",
  "streak.unit.other": "日",
  "streak.done": "今日は完了です。明日また来て続けましょう。",
  "streak.keep": "今日 1 問答えて連続記録を保ちましょう。",
  "streak.start": "今日 1 問答えて連続記録を始めましょう。",
  "streak.last7": "過去 7 日間",
  "streak.studied": "学習した",
  "streak.noStudy": "学習なし",
  "xp.title": "経験値",
  "xp.how": "XP のしくみ",
  "xp.howBody": "同じ学習項目に正解するたびに獲得 XP が増えます：初回は 10 XP、次は 20、30…最大 150。ヒントを使うとその回答の XP は半分になります。不正解では XP は得られませんが、進捗はリセットされません。XP は練習への報酬で、復習の予定は変わりません。",
  "goal.title": "毎日の目標",
  "goal.sr": "毎日の目標：今日は {target} 回答中 {done} 回答を完了、{percent} パーセント。",
  "goal.answersToday": "今日 {done} / {target} 回答",
  "goal.perDay": "1 日の回答数",
  "goal.edit": "目標を編集",
  "goal.invalid": "1〜500 の整数を選んでください。",
  "planner.title": "タイムプランナー",
  "planner.now": "今",
  "planner.1h": "1 時間後",
  "planner.4h": "4 時間後",
  "planner.1d": "1 日後",
  "planner.3d": "3 日後",
  "planner.7d": "7 日後",
  "planner.dueNow": "今 {n} 件が期限：約 {min} 分",
  "planner.caption": "各時点までに期限が来る復習（期限超過を含む）",
  "planner.dueBy": "期限",
  "planner.items": "項目",
  "planner.hint": "現在の復習予定に基づき、学習に合わせて変わります。各行にはそれ以前に期限が来るものがすべて含まれます。",
  "activity.title": "アクティビティ",
  "activity.seeMore": "もっと見る",
  "activity.future": "{day}：未来",
  "activity.day": "{day}：{answers}",
  "activity.dayXp": "{day}：{answers}、{xp} XP",
  "activity.aria": "アクティビティカレンダー：{days}、{answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} 日アクティブ",
  "unit.activeDay.other": "{n} 日アクティブ",
  "activity.less": "少ない",
  "activity.more": "多い",
  "activity.legendFuture": "未来",
  "pb.curriculumHint": "資料のうちどれだけ学習・有効化したか。",
  "pb.conceptsActive": "学習中のコンセプト",
  "pb.activeOf": "{active} / {total}",
  "pb.memory": "記憶",
  "pb.memoryHint": "練習した内容をどれだけ覚えているか。習熟度は復習からの推定値です。",
  "pb.mastery": "習熟度（推定）",
  "pb.itemsTrained": "トレーニング中の項目",
  "pb.markedHard": "難しいとマーク",
  "pb.dueNow": "今すぐ",
  "pb.laterToday": "今日このあと",
  "pb.tomorrow": "明日",
  "pb.next7": "今後 7 日間",
  "pb.newToLearn": "新しく学ぶ",
  "pb.overdue.one": "{n} 問が期限を過ぎています。まずそれらから始めましょう。",
  "pb.overdue.other": "{n} 問が期限を過ぎています。まずそれらから始めましょう。",
  "pb.caption": "このコースで期限が近い問題とおおよその所要時間",
  "pb.when": "いつ",
  "pb.questions": "問題",
  "pb.time": "時間",
  "pb.minutes": "約 {n} 分",
  "study.intent.LEARN": "学習",
  "study.intent.SCHEDULED_REVIEW": "復習",
  "study.intent.PRACTICE": "練習",
  "study.intent.EXAM": "試験",
  "study.intent.CONSOLIDATION": "定着",
  "study.round": "良い回答 {n}/{total}",
  "study.progressAria": "このセッションの進捗",
  "study.progress": "{n} / {total}",
  "study.xpSessionAria": "このセッションで {n} XP",
  "study.ownReview": "自主復習：予定は変わらず、XP もなし",
  "study.leaveResume": "中断（あとで再開）",
  "study.end": "セッションを終了",
  "study.preparing": "セッションを準備中…",
  "study.empty.title": "今は学習するものがありません",
  "study.empty.body": "この学習に該当するものはありません。コンセプトを有効にして新しい内容を追加するか、復習の期限が来たらまた来てください。",
  "study.empty.back": "コースに戻る",
  "study.newMaterial": "新しい内容",
  "study.keyPoints": "要点",
  "study.sources": "出典",
  "study.ready": "準備できました：テストしてください",
  "study.answering": "回答する",
  "study.drawHint": "下に答えを描いてください。AI が模範の図と比較します。",
  "study.note": "メモ（任意）",
  "study.yourAnswer": "あなたの回答",
  "study.notePlaceholder": "図に付け加えることがあれば…",
  "study.answerPlaceholder": "自分の言葉で答えてください…",
  "study.stopListening": "聞き取りを停止",
  "study.speak": "声で答える",
  "study.evaluating": "評価中…",
  "study.submit": "送信",
  "study.skip": "この問題をスキップ",
  "study.dictationOn": "音声入力はブラウザが文字起こしし、音声を音声認識サービスに送信する場合があります。保存されるのはテキストのみで、送信前に編集できます。",
  "study.dictationOff": "音声での回答には Chrome、Edge、Safari が必要です。ここで入力することもできます。",
  "study.drawingCompare": "あなたの図と模範の図",
  "study.yourDrawing": "あなたの図",
  "study.reference": "模範",
  "study.gradedByYou": "あなたが採点",
  "study.needsGrade": "あなたの採点が必要です",
  "study.firstEval": "最初の評価",
  "study.secondOpinion": "セカンドオピニオン",
  "study.afterObjection": "あなたの異議のあと：「{text}」",
  "study.referenceSummary": "模範解答と出典",
  "study.studyConcept": "📖 このコンセプトを学ぶ",
  "study.gradeHow": "どれくらい分かりましたか？",
  "study.gradeYourself": "または自分で採点",
  "study.yourGrade": "あなたの採点",
  "study.retryEval": "もう一度評価する",
  "study.skipNow": "今はスキップ",
  "study.disagree": "評価に納得できませんか？",
  "study.notMemorized": "まだ覚えていません。このセッション中にもう一度出ます。",
  "study.levelNext": "レベル {from} → {to}。次の復習：{when}",
  "study.practiceNote": "練習は復習の予定を変えません。",
  "study.complete": "セッション完了",
  "study.xpSessionPlus": "このセッションで +{n} XP",
  "study.answeredIn": "{answers}、約 {min} 分。",
  "study.wentWell": "{n} 件はうまくいきました。",
  "study.steady": "着実な学習：定着してきています。",
  "study.comeBack": "うまくいかなかったものはすぐに戻ってきます。そうして定着します。",
  "study.stillDue": "現在も期限のもの：{n} 件（約 {min} 分）。",
  "study.nothingDue": "今は他に期限のものはありません。",
  "study.done": "完了",
  "study.noXp": "この回答では XP は得られません（練習、または復習の期限前）。",
  "study.correctXp": "正解：+{n} XP",
  "study.halfXp": "（ヒント使用：XP は半分）",
  "study.hintLabel": "ヒント",
  "study.noHint": "この問題にはヒントがありません。",
  "study.showHint": "ヒントを表示",
  "study.hintHalves": "ヒントを使うとこの回答の XP は半分になります。",
  "study.revealHint": "ヒントを見る",
  "study.plusZero": "+0 XP",
  "study.onlyCorrectSelf": "正解だけが XP を獲得できます。自分で付けた「難しい」「良い」「簡単」も含まれます。",
  "study.onlyCorrect": "完全に正しい回答だけが XP を獲得できます。次の報酬までの進捗は保たれます。",
  "study.awardCorrect": "正解",
  "study.awardHint": "ヒント使用",
  "study.ordinal": "この項目の {n} 回目の正解",
  "study.ordinalHalf": "この項目の {n} 回目の正解、{base} の半分",
  "study.batchDone": "バッチの定着完了",
  "study.correctAnswers": "正解数",
  "study.xpThisSession": "このセッションの XP",
  "study.whatNext": "このあと",
  "study.whatNextBody": "最後のラウンドで正解した項目は約 4 時間後に復習に戻ります。それ以外は次のバッチを待ちます。",
  "study.waiting.one": "あと {n} 件が待機中",
  "study.waiting.other": "あと {n} 件が待機中",
  "study.batchNotAll": "このバッチは完了しましたが、コンセプト全体ではありません：{waiting}。",
  "study.allRounds": "この概念で待機していた項目はすべて三回うまく答えられました。",
  "study.nextBatch": "次のバッチ",
  "study.conceptCosts": "今コンセプトを見るとヒントを使ったことになり、この回答の XP は半分になります。",
  "study.openConcept": "コンセプトを開く",
  "study.dontRemember": "📖 思い出せませんか？このコンセプトを学びましょう",
  "study.refDrawing": "模範の図",
  "dispute.title": "AI にもう一度見てもらう",
  "dispute.testAi": "テスト用 AI はあなたの異議を読めません。セカンドオピニオンでも同じ評価になります。下で自分で採点してください。",
  "dispute.why": "なぜ納得できませんか？",
  "dispute.placeholder": "評価のどこが間違っていたか書いてください…",
  "dispute.hint": "AI があなたの異議を読んで再評価します。両方の意見が表示され、評価が変わるのは下で選んだときだけです。",
  "dispute.asking": "問い合わせ中…",
  "dispute.ask": "セカンドオピニオンを求める",
  "eval.correct": "正しさ",
  "eval.complete": "完全さ",
  "eval.understanding": "理解",
  "eval.precise": "正確さ",
  "eval.Strong": "良好",
  "eval.Partial": "一部",
  "eval.Weak": "弱い",
  "eval.scoreBreakdown": "スコアの内訳",
  "eval.right": "正しい",
  "eval.missing": "不足",
  "eval.misconception": "誤解",
  "eval.materialSays": "資料には次のようにあります",
  "eval.covered": "回答でカバーできた内容",
  "eval.failed": "回答を評価できませんでした。",
  "eval.aiEvaluation": "AI の評価：{verdict}",
  "eval.insufficient": "コースの資料ではこの点が十分にカバーされておらず、採点できません。",
  "eval.testAiTitle": "テスト用 AI。",
  "eval.testAiBody": "この評価は、模範解答と単語を比べるだけの代用プログラムによるものです。言い換えや異議は理解できません。模範解答を確認して自分で採点するか、本物の AI を接続してください。",
  "conceptPanel.title": "このコンセプトを学ぶ",
  "conceptPanel.next": "学習した — 次の問題へ",
  "conceptPanel.closeAria": "コンセプトを閉じる",
  "conceptPanel.loading": "コンセプトを読み込み中…",
  "conceptPanel.openFull": "コンセプトの全ページを新しいタブで開く",
  "dictation.blocked": "マイクがブロックされています。音声入力するにはブラウザのサイト設定で許可してください。",
  "dictation.network": "音声認識にはインターネット接続が必要です。",
  "dictation.noMic": "マイクが見つかりませんでした。",
  "dictation.stopped": "音声認識が予期せず停止しました。そのまま入力を続けられます。",
  "concept.activate": "有効にする",
  "concept.activateHelp": "資料からこのコンセプトの問題を準備して、学習できるようにします。",
  "concept.markStudied": "学習済みにする",
  "concept.markStudiedHelp": "別の場所で学習済み：記録だけして、まだ問題は準備しません。",
  "concept.activateAgainHelp": "もう一度学びます。問題がセッションに戻ってきます。",
  "concept.pause": "一時停止",
  "concept.pauseHelp": "しばらく問題を止めます。何も失われません。",
  "concept.deactivate": "無効にする",
  "concept.deactivateHelp": "学習と復習から外します。回答と履歴は保持されます。",
  "concept.resume": "再開",
  "concept.resumeHelp": "問題を学習と復習に戻します。",
  "concept.sourceDeleted": "このコンセプトの元になった資料は削除されました。残す、編集する、削除するのいずれかを選んでください。",
  "concept.manage": "このコンセプトを管理",
  "concept.loadingItems": "学習項目を読み込み中…",
  "concept.preparing": "学習項目を準備中…",
  "concept.itemsFailed": "学習項目を準備できませんでした。",
  "concept.noSource": "このコンセプトには学習項目の元になる資料がありません。",
  "concept.whatToStudy": "学習内容",
  "concept.reviewOwnHelp": "いつでもこのコンセプトのテストを受けられます。復習の予定は変わらず、XP も得られません。",
  "concept.reviewOwn": "🔁 自分で復習",
  "concept.readThen": "これらを読んでから、下の「このコンセプトを学びました」を押して練習しましょう。",
  "concept.testMe": "🔁 これでテストする",
  "concept.hideDetails": "詳細を隠す",
  "concept.details": "詳細",
  "concept.level": "レベル {n}",
  "concept.markedHard": "難しいとマーク済み",
  "concept.notTraining": "トレーニング対象外",
  "concept.state": "状態",
  "concept.levelLabel": "レベル",
  "concept.nextReview": "次の復習",
  "concept.reviews": "復習回数",
  "concept.lapses": "忘れた回数",
  "concept.inTraining": "トレーニング中",
  "concept.questions": "問題",
  "concept.sourcesTitle": "出典",
  "concept.loadingSources": "出典を読み込み中…",
  "concept.noSources": "出典の抜粋はありません。",
  "concept.misconceptions": "繰り返される誤解",
  "drawing.answerBy": "図で答える",
  "drawing.studentsDraw": "学習者は図を描いてこの問題に答えます。AI が描いた図とこの図を比較します。",
  "drawing.youDraw": "この問題には図を描いて答えます。AI があなたの図とこの図を比較します。",
  "drawing.referenceAlt": "模範の図",
  "drawing.explain": "図で答える問題（分子、図解、グラフなど）では、正しい図を追加すると、学習者は文章の代わりに図を描いて答えます。",
  "drawing.save": "この図を保存",
  "drawing.replace": "画像に置き換える…",
  "drawing.upload": "図をアップロード…",
  "drawing.drawNew": "新しく描く",
  "drawing.drawHere": "ここで描く",
  "drawing.words": "代わりに文章で答える",
  "drawing.tools": "描画ツール",
  "drawing.pen": "✏️ ペン",
  "drawing.eraser": "🧽 消しゴム",
  "drawing.thick": "太い線",
  "drawing.thin": "細い線",
  "drawing.undo": "↶ 元に戻す",
  "drawing.clear": "消去",
  "drawing.area": "描画エリア：ここに答えを描いてください",
  "drawing.photoUpload": "紙に描きましたか？写真をアップロード",
  "drawing.photoError": "このファイルはブラウザで読める画像ではありません。JPEG か PNG の写真を試してください。",
  "drawing.photoAlt": "図の写真",
  "drawing.drawInstead": "代わりに描く",
  "q.title": "問題",
  "q.introOwn": "問題を選んで、削除・一時停止・再開・移動ができます。⠿ をドラッグして並べ替え、編集してタイトル、表現、期待される答えを直せます。",
  "q.introManaged": "このコースはマーケットのものです。問題は作成者が更新し続けます。問題を選んで一時停止・再開するか、自分用の優先度を付けられます（あなただけに表示）。",
  "q.search": "問題を検索",
  "q.searchPlaceholder": "問題と答えを検索",
  "q.allPriorities": "すべての優先度",
  "q.priorityOnly": "{label}のみ（{n}）",
  "q.deselectAll": "すべて選択解除",
  "q.selectAll": "すべて選択（{n}）",
  "q.selectAllShown": "表示中のものをすべて選択（{n}）",
  "q.collapseAll": "すべて折りたたむ",
  "q.expandAll": "すべて展開",
  "q.selectedAria": "選択中の問題",
  "q.selectedCount": "{n} 件を選択中",
  "q.moveTo": "移動先…",
  "q.setPriority": "優先度を設定",
  "q.setPriorityPlaceholder": "優先度を設定…",
  "q.reviewSelectedHelp": "選んだ問題で今すぐテストを受けます。復習の予定は変わらず、XP も得られません。",
  "q.clearSelection": "選択を解除",
  "q.verb.delete": "削除しました",
  "q.verb.pause": "一時停止しました",
  "q.verb.resume": "再開しました",
  "q.verb.move": "移動しました",
  "q.verb.set_priority": "更新しました",
  "unit.question.one": "{n} 問",
  "unit.question.other": "{n} 問",
  "unit.chapter.one": "{n} 章",
  "unit.chapter.other": "{n} 章",
  "unit.topic.one": "{n} トピック",
  "unit.topic.other": "{n} トピック",
  "unit.concept.one": "{n} コンセプト",
  "unit.concept.other": "{n} コンセプト",
  "unit.group.one": "空になったグループ {n} 件",
  "unit.group.other": "空になったグループ {n} 件",
  "q.newConcepts.one": "新しいコンセプト {n} 件",
  "q.newConcepts.other": "新しいコンセプト {n} 件",
  "q.removedConcepts.one": "空のコンセプト {n} 件を削除",
  "q.removedConcepts.other": "空のコンセプト {n} 件を削除",
  "q.noticeBulk": "{verb} {questions}{extra}。",
  "q.noticeDeleted": "{questions} を削除しました。",
  "q.noticeDeletedGroups": "{questions} と {groups} を削除しました。",
  "q.confirmDelete": "{questions} を削除しますか？回答と復習履歴も一緒に削除されます。{also}",
  "q.confirmAlso": "  質問がなくなった {groups} も削除されます。",
  "q.emptySearch": "この検索に一致する問題はありません。",
  "q.empty": "まだ問題がありません。コンセプトを有効にするか、自分の問題と答えをインポートしてください。",
  "q.clearToReorder": "並べ替えるには検索をクリアしてください。",
  "q.select": "選択：{text}",
  "q.otherWordings.one": "他に {n} 件の表現",
  "q.otherWordings.other": "他に {n} 件の表現",
  "q.editAria": "問題を編集",
  "q.titleLabel": "タイトル（一覧に表示）",
  "q.wordings": "問題の表現",
  "q.wording": "表現 {n}",
  "q.addWording": "+ 別の表現を追加",
  "q.expected": "期待される答え",
  "q.prio1": "必須：中核、必ず知るべき",
  "q.prio2": "重要：知っておくべき",
  "q.prio3": "追加：補足、より詳しい内容",
  "q.keyPoints": "要点（1 行に 1 つ、最大 10 個）",
  "q.moveAria": "問題を移動",
  "q.moveHeading": "{questions} の移動先",
  "q.choose": "トピックかコンセプトを選択…",
  "q.topicOption": "トピック：{title}（各問題は自分のコンセプトを保持）",
  "q.conceptOption": "   ↳ コンセプトへ：{title}",
  "q.removeEmpty": "質問がなくなったコンセプトを削除",
  "q.moveHint": "問題は復習の進捗を保ちます。有効でないコンセプトでは、有効になるまで復習されません。",
  "q.move": "移動",
  "q.groupSelect": "{label} のすべての問題を選択",
  "mat.chapterTitle": "章の資料",
  "mat.collapseLabel": "学習資料",
  "mat.files.one": "{n} ファイル",
  "mat.files.other": "{n} ファイル",
  "mat.uploading": "アップロード中…",
  "mat.upload": "資料をアップロード",
  "mat.uploadQa": "問題と答えをアップロード",
  "mat.paste": "テキストを貼り付け",
  "mat.howTo": "問題と答えの準備方法",
  "mat.howToBody": "PDF、Word、テキスト、Markdown のファイルをアップロードしてください。各問題は行頭を「Domanda:」、期待される答えを「Risposta:」（または「Question:」/「Answer:」）で始めます。見出しが問題をトピックにまとめます。",
  "mat.howToBody2": "各問題は未学習のコンセプトになり、あなたの答えが期待される答えになります。有効にすると復習を始められます。インポートには AI を使いません。",
  "mat.loading": "資料を読み込み中…",
  "mat.none": "まだ資料がありません。PDF、Word、PowerPoint、テキスト、Markdown のファイルをアップロードしてください。",
  "mat.file": "ファイル",
  "mat.status": "状態",
  "mat.passages": "抜粋",
  "mat.added": "追加日",
  "mat.actions": "操作",
  "mat.qa": "Q&A",
  "mat.processing": "処理中…",
  "mat.ready": "準備完了",
  "mat.failed": "失敗",
  "mat.download": "ダウンロード",
  "mat.confirmDelete": "{name} を削除しますか？そこから作られたコンセプトは確認が必要としてマークされます。",
  "mat.pasteAria": "テキストを貼り付け",
  "mat.pastePlaceholder": "例：第 3 回講義のノート",
  "mat.thisTextIs": "このテキストは",
  "mat.asMaterial": "学習資料",
  "mat.asQa": "問題と答え（Domanda: / Risposta:）",
  "mat.text": "テキスト",
  "mat.textPlaceholderQa": "# トピック\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# 見出し\nあなたのノート…",
  "mat.adding": "追加中…",
  "mat.addText": "テキストを追加",
  "mat.pastedName": "貼り付けたテキスト {when}",
  "prop.title": "提案されたカリキュラム",
  "prop.reading": "AI が資料を読んでいます…",
  "prop.applied": "この提案はすでに適用されています。",
  "prop.failed": "AI はカリキュラムを提案できませんでした。",
  "prop.blank": "すべての章、トピック、コンセプトにタイトルが必要です。",
  "prop.longMaterial": "資料が長いため、{total} 個の抜粋のうち最初の {used} 個が対象です。",
  "prop.dropped": "提案された {n} 個のコンセプトは、資料と結び付けられなかったため除外されました。",
  "prop.hint": "下の内容は自由に編集できます：名前の変更、並べ替え、トピック間のコンセプト移動、統合、削除、追加。何も有効にはなりません。何を学ぶかはあとであなたが選びます。",
  "prop.chapterTitle": "章のタイトル",
  "prop.deleteChapter": "章を削除",
  "prop.accept": "カリキュラムを承認",
  "prop.reject": "提案を却下",
  "prop.topicAria": "トピック {title}",
  "prop.existingTopic": "既存のトピック",
  "prop.topicTitle": "トピックのタイトル",
  "prop.moveTopicUp": "トピックを上へ",
  "prop.moveTopicDown": "トピックを下へ",
  "prop.deleteTopic": "トピックを削除",
  "prop.conceptTitle": "コンセプトのタイトル",
  "prop.exists": "すでに存在",
  "prop.moveConceptUp": "コンセプトを上へ",
  "prop.moveConceptDown": "コンセプトを下へ",
  "prop.moveToTopic": "トピックへ移動",
  "prop.untitled": "無題のトピック",
  "prop.merge": "次と統合",
  "prop.addConcept": "+ コンセプトを追加",
  "mkt.intro": "他の LEARNABLE ユーザーが作ったコースです。自分のコースに追加して、自分の予定で学べます。作成者が更新し続けます。自分のコースを共有するには、コースを開いて「マーケットページ」を入力してください。",
  "mkt.categories": "カテゴリー",
  "mkt.all": "すべて",
  "mkt.searchPlaceholder": "タイトルまたは説明で検索",
  "mkt.level": "レベル",
  "mkt.language": "言語",
  "mkt.size": "規模",
  "mkt.sort": "並べ替え",
  "mkt.any": "指定なし",
  "mkt.loading": "コースを読み込み中…",
  "mkt.noMatch": "これらの条件に合うコースはまだありません。",
  "mkt.publishedByMe": "自分が公開",
  "mkt.status.DRAFT": "下書き",
  "mkt.status.PUBLISHED": "公開中",
  "mkt.status.UNPUBLISHED": "非公開",
  "mkt.version": "バージョン {n}",
  "mkt.students.one": "{n} 人の学習者",
  "mkt.students.other": "{n} 人の学習者",
  "mkt.editCourse": "コースとそのページを編集",
  "mkt.by": "作成者 {author}",
  "mkt.inYourCourses": "あなたのコースにあります",
  "mkt.loadingCourse": "コースを読み込み中…",
  "mkt.updated": "{date} 更新",
  "mkt.statStudents": "学習者",
  "mkt.yourCourse": "あなたのコース",
  "mkt.draftTag": "下書き",
  "mkt.notPublishedTag": "非公開",
  "mkt.open": "マイコースで開く",
  "mkt.addBack": "マイコースにもう一度追加",
  "mkt.add": "マイコースに追加 · {price}",
  "mkt.about": "このコースについて",
  "mkt.learn": "学べること",
  "mkt.audience": "対象者",
  "mkt.hiddenNote": "コースがマイコースに入ると、問題と答えが見えるようになります。LEARNABLE の中で学習し、作成者の資料はダウンロードできません。",
  "sales.originTitle": "🛒 マーケットより",
  "sales.madeBy": "作成者：{author}（バージョン {version}）。章・問題・答えは作成者が更新し続けるため、ここでは編集できません。更新は自動的に届きます。",
  "sales.yourStudy": "学習はあなた自身のものです：コンセプトの有効化、一時停止、回答、復習の予定、XP、各問題に付ける優先度（あなただけに表示）。",
  "sales.seePage": "マーケットのページを見る",
  "sales.title": "🛒 マーケットページ",
  "sales.pPublished": "公開中 · バージョン {n}",
  "sales.pNot": "非公開",
  "sales.pDraft": "下書き",
  "sales.pNone": "未共有",
  "sales.explain": "このコースを他のユーザーと共有します。ここでは追加前に唯一見えるページを書きます：内容、対象者、学べること。章のタイトルと問題数も見えますが、問題そのものは追加後にだけ見え、アップロードした資料は見えません。",
  "sales.seeAsOthers": "他の人からの見え方を確認",
  "sales.edit": "マーケットページを編集",
  "sales.write": "マーケットページを書く",
  "sales.subtitle": "サブタイトル",
  "sales.subtitleHint": "（1 行で。例：「口頭試験の全 300 問、模範解答つき」）",
  "sales.category": "カテゴリー",
  "sales.description": "説明",
  "sales.descriptionHint": "（内容、作り方、使い方）",
  "sales.outcomes": "学習者が学べること",
  "sales.outcomesHint": "（1 行に 1 つ、最大 8 個）",
  "sales.tags": "タグ",
  "sales.tagsHint": "（カンマ区切り、最大 8 個）",
  "sales.saveDraft": "下書きを保存",
  "sales.savePage": "ページを保存",
  "sales.publish": "公開",
  "sales.publishUpdate": "更新を公開",
  "sales.publishHintUpdate": "現在の章・問題・答えを、このコースを持つ全員に送ります。各自の進捗は保たれます。",
  "sales.publishHint": "コースをマーケットに表示します。今のところ無料です。編集を続け、あとで更新を公開できます。",
  "sales.rights": "問題と答えは私が共有できるものです（自分で書いた、または元の資料の権利を持っています）。",
  "sales.publishing": "公開中…",
  "sales.publishUpdateBtn": "更新を公開",
  "sales.unpublish": "公開を停止",
  "sales.noteSaved": "保存しました。マーケットページにすぐ反映されます。",
  "sales.noteDraft": "下書きを保存しました。公開するまで他の人には見えません。",
  "sales.notePublishedV": "バージョン {n} を公開しました。このコースを持つ全員に最新の問題が届きます。",
  "sales.notePublished": "公開しました！他のユーザーがマーケットで見つけられます。",
  "sales.noteUnpublished": "公開を停止しました。新しい人は見つけられません。すでに持っている人はそのまま使えます。",
  "prog.empty": "コースを作成して学習を始めると、進捗が表示されます。",
  "prog.weakConcepts": "苦手なコンセプト",
  "prog.weakMeta": "忘れた回数：{lapses} · 難しいとマーク：{hard}",
  "prog.byChapter": "章とトピック別",
  "prog.colChapter": "章 / トピック",
  "weak.intro": "最近の回答で見つかった間違いを、コンセプト別に表示します。その項目への最新の回答に現れなくなると消えます。練習は復習の予定を変えません。",
  "weak.loading": "最近の回答を確認中…",
  "weak.empty": "今のところ繰り返される間違いはありません。回答を続けると、ここに表示されます。",
  "weak.practiceTop.one": "最優先の {n} 個のコンセプトを練習",
  "weak.practiceTop.other": "最優先の {n} 個のコンセプトを練習",
  "weak.practiceThis": "これを練習",
  "weak.seen.one": "{n} 回見つかり、最後は {date}",
  "weak.seen.other": "{n} 回見つかり、最後は {date}",
  "home.intro": "予定された復習で学んだことを保ちます。期限の件数は復習セッションと同じルールで数えます。",
  "home.noCourses": "まだコースがありません。",
  "home.createOnDashboard": "ダッシュボードで作成",
  "home.meta": "今 {due} 件が期限 · {trained} 項目中 {introduced} 項目を導入済み",
  "activity.pageIntro": "過去 1 年間の 1 日あたりの完了した回答数（あなたのタイムゾーン）。正解でも不正解でも、最終的な評価がついた回答が数えられます。",
  "reset.title": "パスワードをリセット",
  "reset.intro": "アカウントのメールアドレスを入力してください。新しいパスワードを設定するリンクを送ります。リンクは 1 回だけ、30 分間有効です。",
  "reset.send": "リセットリンクを送信",
  "reset.sentMessage": "このメールアドレスのアカウントがある場合、パスワードをリセットするリンクを送信しました。受信トレイ（と迷惑メール）を確認してください。",
  "reset.back": "サインインに戻る",
  "reset.chooseTitle": "新しいパスワードを設定",
  "reset.incomplete": "このリンクは不完全です。メールのリンクをもう一度開くか、新しいリンクを請求してください。",
  "reset.done": "パスワードを変更しました。すべての端末からサインアウトされました。新しいパスワードでサインインしてください。",
  "reset.newPassword": "新しいパスワード",
  "reset.repeat": "新しいパスワードを再入力",
  "reset.tooShort": "{n} 文字以上にしてください。",
  "reset.mismatch": "2 つのパスワードが一致しません。",
  "reset.set": "新しいパスワードを設定",
  "source.aria": "出典の抜粋",
  "source.closeAria": "出典を閉じる",
  "source.loading": "抜粋を読み込み中…",
  "source.open": "出典の抜粋を開く",
  "course.loadingCurriculum": "カリキュラムを読み込み中…",
  "mkt.addPlain": "マイコースに追加",
  "sales.pageName": "マーケットページ",
};
